var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"grey3"}},[_c('v-card-text',{staticClass:"text-center"},[_c('span',{staticClass:"total-desc primary--text text-uppercase"},[_vm._v("Total alocado")]),_c('span',{staticClass:"total-value"},[_c('span',[_vm._v("R$")]),_vm._v(" "+_vm._s(_vm.currency(_vm.totalApplied)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }